var map = {
	"./client_brandloyalty.png": "e4ff",
	"./client_efteling.png": "3eab",
	"./client_hhnk.png": "ce9c",
	"./client_johenschede.png": "aaaa",
	"./client_joof.png": "14bb",
	"./client_manu.png": "76d2",
	"./client_muzieum.png": "bedf",
	"./client_oog.png": "a0f5",
	"./client_thibo.png": "b77c",
	"./client_vogels.png": "2394",
	"./client_weener_xl.png": "27ee",
	"./client_wesp.png": "5311",
	"./client_zlimthuis.png": "2a0e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "060a";